import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import get from 'lodash/get';
export default {
  name: 'CoreTwoFactorAuthModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVerifyToken: '',
      qrImage: null,
      setupStep: 0,
      recoveryCodes: [],
      errorVerify: false,
      errorQrCode: false
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  watch: {
    isOpen(value) {
      if (value) {
        this.getQRCode();
        this.resetModal();
      }
    }
  },
  methods: {
    get,
    resetModal() {
      this.setupStep = 0;
      this.errorQrCode = false;
      this.errorVerify = false;
      this.inputVerifyToken = '';
    },
    getQRCode() {
      const userid = get(this, '$store.state.authentication.user.id') || null;
      ApiService.enableTwoFactorAuth(userid).then(res => {
        this.qrImage = res.qr;
      }).catch(() => {
        this.errorQrCode = true;
      });
    },
    handleQrCodeScanned() {
      this.setupStep = 1;
    },
    handleCodeChanged() {
      if (this.errorVerify) {
        this.errorVerify = false;
      }
    },
    handleCodeEntered() {
      const userid = get(this, '$store.state.authentication.user.id') || null;
      ApiService.enableTwoFactorAuth(userid, this.inputVerifyToken).then(res => {
        if (!res.recoveryCodes) {
          this.$emit('close');
          return;
        }
        this.setupStep = 2;
        this.$emit('enabled');
        this.recoveryCodes = res.recoveryCodes;
      }).catch(() => {
        this.errorVerify = true;
      });
    }
  }
};